import React, { Fragment, useEffect, useState } from "react";
import TextContentInfo from "../Components/TextContentInfo";
import Flatpickr from "../Components/Flatpickr";
import { Box } from "@mui/material";
import Modal from "@mui/material/Modal";
import AppHeader from "../Components/navigation/AppHeader";
import { dataInvoice } from "../utils/helpers";
import {
  useHandleViewResultInvoice,
  useInitialResultsDataInvoice,
} from "../hooks";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { PdfViewer } from "../Components";
import Table from "../Components/Table/Table";
import { changeLoading } from "../slices";

export default function Invoices() {
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [resultsPerPage, setResultsPerPage] = useState(100);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { IDPacient, id, role } = useSelector((state) => state.user);
  const [examinationData, setExaminationData] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [handleViewResultPdf, openModal, handleCloseModal, base64Data, error] =
    useHandleViewResultInvoice();
  const handleViewResult = async ([IdInvoice]) => {
    handleViewResultPdf(IdInvoice, token);
  };
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };
  const handleResultsPerPageChange = (event) => {
    setResultsPerPage(parseInt(event.target.value));
    setCurrentPage(0);
  };
  const { fetchResultsDataInvoice, fetchedData } =
    useInitialResultsDataInvoice();

  useEffect(() => {
    if (location.state?.data && location.state.data.length > 0) {
      setExaminationData(location.state.data);
    }
  }, [location.state?.data, navigate]);

  useEffect(() => {
    if (fetchedData && fetchedData.length > 0) {
      setExaminationData(fetchedData);
    }
  }, [fetchedData]);
  const handleShowAllResults = async () => {
    if (!dateFrom || !dateTo) return;
    dispatch(changeLoading(true));
    if (IDPacient) {
      const newData = await fetchResultsDataInvoice({
        dateTo,
        dateFrom,
      });
      setExaminationData(newData || []);
    } else if (id) {
      const newData = await fetchResultsDataInvoice({
        dateTo,
        dateFrom,
      });
      setExaminationData(newData || []);
    }

    dispatch(changeLoading(false));
  };
  const noResultsFound = examinationData.length === 0;
  return (
    <Fragment>
      <TextContentInfo text="Фактури" />
      {errorMessage && <div id="badRequest">{error}</div>}
      <Flatpickr
        dateFrom={dateFrom}
        dateTo={dateTo}
        setDateFrom={setDateFrom}
        setDateTo={setDateTo}
        handleShowAllResults={handleShowAllResults}
        //    filterEGN={filterEGN}
        //    setFilterEGN={setFilterEGN}
        //    filterName={filterName}
        //    setFilterName={setFilterName}
        //    filterIme={filterIme}
        //    setFilterIme={setFilterIme}
        //    setErrorMessage={setErrorMessage}
      />

      <Table
        results={examinationData}
        resultCell={["InvoiceDateStr", "InvoiceNom", "InvoiceTypeName"]}
        currentPage={currentPage}
        resultsPerPage={resultsPerPage}
        handleViewResult={handleViewResult}
        onClickData={["IdInvoice"]}
        handlePageChange={handlePageChange}
        handleResultsPerPageChange={handleResultsPerPageChange}
        text={dataInvoice}
        buttonText="Виж документ"
        searchTerm={searchTerm}
        // onSearchChange={handleSearchChange}
        // filterEGN={filterEGN}
        // filterName={filterName}
        noResultsFound={noResultsFound}
        // setOpenModal2={setOpenModal2}
        // setPatientInfo={setPatientInfo}
        // setResultsData={setResultsData}
        // handleResults={handleResults}
      />
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 25000,
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            bgcolor: "background.paper",
            borderRadius: 1,
            p: 2,
            boxShadow: 24,
          }}
        >
          <AppHeader />
          {base64Data && (
            <PdfViewer
              base64Data={base64Data}
              //   fileName={`${examinationData[0].DateRefferal}_${examinationData[0].Paket}_${examinationData[0].GivenPacName}_${examinationData[0].MiddlePacName}_${examinationData[0].FamilyPacName}`}
              handleCloseModal={handleCloseModal}
            />
          )}
        </Box>
      </Modal>
    </Fragment>
  );
}
